const { commonConfig } = require('@alfa-bank/assr-common-config');
const { cdnPlugin } = require('@plotva/assr-core-plugins');

const { getCounters } = require('./src/counters/index.cjs');
const { favicon } = require('./src/favicon.cjs');

const { name, version, dependencies } = require('./package.json');

const config = {
    ...commonConfig,
    postcss: {
        customPropertiesFile: 'node_modules/@alfalab/core-components/themes/site.css'
    },
    cssHashLen: 5,
    widgetsContexts: ['@alfa-bank', '@plotva'],
    additionalWidgetPackages: [],
    instanceName: name,
    instanceVersion: version,
    getDependencies: () => dependencies,
    plugins: [{
        plugin: cdnPlugin,

        config: {
            cdnPublicPath: process.env.CDN_PUBLIC_PATH,
            domainPattern: '(https?:)?//alfabank[.]st'
        }
    }],
    getCounters: getCounters,
    getFavicon: () => favicon
};

module.exports = config; 
